import { executePostRequest } from '@api/client';
import { createAuthenticateApiPath } from '@routing/apiUrls';
import { Authenticate } from '@models/Authenticate';

export const authenticate = async (data: Authenticate): Promise<Authenticate> => {
    const result = await executePostRequest<Authenticate>(createAuthenticateApiPath(data.tenantId), data);
    return result.data;
};
